module.exports = __webpack_public_path__ + "static/media/Coves-of-Northville-First-Amendment-Master-Deed.fcfd7c9b.pdf";